export const JSON_FETCH_HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
}